// extracted by mini-css-extract-plugin
var _1 = "ratedisclosures_effectivedate__fkc-o";
var _2 = "ratedisclosures_wrapper__tpxuw";
export { _1 as "effectiveDate", _2 as "wrapper" }
